import { useFeature } from 'hooks'
import { FormattedMessage, useIntl } from 'react-intl'
import { BaseBudget } from 'typings'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { messages } from '../messages'

type Props = {
  budget: BaseBudget | undefined
}

export function BudgetRow(props: Props) {
  const { budget } = props

  const { formatCurrency } = useNumbers()
  const { $t } = useIntl()

  const { getFeature } = useFeature()

  const budgetFeature = getFeature('budget')

  if (!budgetFeature) {
    return null
  }

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.budget.title} />
      </SummaryRow.Title>
      <SummaryRow.Value>
        <Tag>
          {budget
            ? formatCurrency(budget.amount)
            : $t(messages.budget.unlimited)}
        </Tag>
      </SummaryRow.Value>
    </SummaryRow>
  )
}
